export enum EVENTS {
  DELIVERIES_STATUS = "deliveriesStatus",
  PACKAGES_STATUS = "packagesStatus",
  MODAL_OPEN = "modalOpen",
  MODAL_CLOSE = "modalClose",
}

export enum DELIVERY_STATES {
  sentToNative = "sentToNative",
  queued = "queued",
  failed = "failed",
  downloading = "downloading",
  installing = "installing",
  installed = "installed",
  launched = "launched",
  update = "update",
  cancelled = "cancelled",
  error = "error",
}

export enum ERROR_CODES {
  MALFORMED_REQUEST = 100,
  UNKNOWN_ROUTE = 101,
  DELIVERY_ERROR = 200,
  INSUFFICIENT_STORAGE = 201,
}
